module.exports = __webpack_public_path__ + "img/文档.65170037.png";